import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import css from './RenderFeaturedLocations.module.css';
import Slider from 'react-slick';

import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';

import { ListingCard } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { searchListings } from '../../SearchPage/SearchPage.duck';
import { useConfiguration } from '../../../context/configurationContext';
import { getListingsById } from '../../../ducks/marketplaceData.duck';
import { cardRenderSizes, getSearchParams, getUserSubscriptionBadge } from '../../../util/genericHelpers';

function RenderFeaturedLocations({ listings }) {
  const intl = useIntl();
  const config = useConfiguration();
  const dispatch = useDispatch();

  const platinumListings = listings.filter(listing => {
    const badge = getUserSubscriptionBadge(listing);
    return badge === 'Platinum';
  });
  useEffect(() => {
    dispatch(
      searchListings({
        searchParams: {
          ...getSearchParams(),
          perPage: 100,
          include: ['author', 'images'],
        },
        config,
      })
    );
  }, [dispatch, config]);

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1128, settings: { slidesToShow: 4 } },
      { breakpoint: 991, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className={css.sectionLocations}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              {intl.formatMessage({
                id: 'RenderFeaturedLocations.heading',
                defaultMessage: 'Our most unique locations',
              })}
            </h2>
            <p>
              {intl.formatMessage({
                id: 'RenderFeaturedLocations.subheading',
                defaultMessage:
                  'Most liked and popular locations, unique, thrilling and listed on our customer’s top picks.',
              })}
            </p>
          </div>
        </div>

        <div className={css.categorySlider}>
          <Slider {...sliderSettings}>
            {platinumListings.map(l => (
              <ListingCard
                className={css.listingCard}
                key={l.id.uuid}
                listing={l}
                renderSizes={cardRenderSizes(false)}
                setActiveListing={() => { }}
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default RenderFeaturedLocations;
